module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"defaultOperationalDepartment":"Default operating department","defaultEconomicalDepartment":"Default economical department"},"no":{"defaultOperationalDepartment":"Standard operativ avdeling","defaultEconomicalDepartment":"Standard økonomisk avdeling"}}')
  delete Component.options._Ctor
}
